import React, { useState } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
  FieldInputDollar,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  ssnMasking,
  clearFieldValues,
} from "../../../utils";
import {
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
  downloadAggregatedReport,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import "react-input-range/lib/css/index.css";
import * as fileSaver from "file-saver";
import { date } from "yup";
import moment from "moment";

const today = new Date();
const initialValues = {
  toDate: new Date(today.setDate(today.getDate())),
  fromDate: new Date(today.setDate(today.getDate() - 30)),
  companyId: null,
  planName: null,
  groupBy: 1,
};

const groupByOptions = [
  {
    label: "1 month",
    value: 1,
  },
  {
    label: "2 Months",
    value: 2,
  },
  {
    label: "3 Months",
    value: 3,
  },
  {
    label: "4 Months",
    value: 4,
  },
  {
    label: "5 Months",
    value: 5,
  },
  {
    label: "6 Months",
    value: 6,
  },
  {
    label: "7 Months",
    value: 7,
  },
  {
    label: "8 Months",
    value: 8,
  },
  {
    label: "9 Months",
    value: 9,
  },
  {
    label: "10 Months",
    value: 10,
  },
  {
    label: "11 Months",
    value: 11,
  },
  {
    label: "12 Months",
    value: 12,
  },
];

const AggregatedPeriodicReport = (props) => {
  const formName = manageReportsFormNames.AGGREGATED_REPORT;
  const fields = formFields[formName];
  const [planList, setPlanList] = useState([]);

  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });
  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });
  const exportReportFile = (data) => {
    downloadAggregatedReport(data)
      .then((response) => {
        var blob = new Blob([response], {
          type: "application/pdf",
        });
        fileSaver.saveAs(
          blob,
          "Aggregated Summary report_" + moment().format("MMDDYYYY")
        );
      })
      .catch((error) => {});
  };
  const onSubmit = (values) => {
    var filters = {
      companyId: values.companyId ? values.companyId : 0,
      sponsorOrganizationId: values.sponsorOrganizationId
        ? values.sponsorOrganizationId
        : 0,
      planName: values.planName,
      planId: values.companyId
        ? planList.length === 1
          ? planList[0].planId
          : !values.planId
          ? 0
          : values.planId
        : 0,
      masterPlanId: values.sponsorOrganizationId
        ? planList.length === 1
          ? planList[0].planId
          : !values.planId
          ? 0
          : values.planId
        : 0,
      masterPlanName: values.sponsorOrganizationName,
      fromDate: usDateFormat(values.fromDate),
      toDate: usDateFormat(values.toDate),
      groupBy: values.groupBy,
    };
    exportReportFile(filters);
  };

  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  return (
    <ManageReportLayout rptName="Aggregated Summary Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex flex-col w-100">
                    <div className="d-flex w-100 ">
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "150px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.sponsorOrganizationName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.sponsorOrganizationName])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-3">
                        <Field
                          size="sm"
                          isRequired
                          label={`plan Id ${
                            !values[fields.companyName] ? "*" : ""
                          }`}
                          name={fields.planName}
                          value={values[fields.planName]}
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Period Start Date"
                          isRequired
                          name={fields.fromDate}
                          value={usDateFormat(values[fields.fromDate])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.fromDate, "")}
                          validate={(value) =>
                            ["", undefined, null, "Select One"].includes(
                              value
                            ) && isEmpty(values[fields.fromDate])
                              ? "Required"
                              : null
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.fromDate, value)
                              }
                              value={usDateFormat(values[fields.fromDate])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Period End Date"
                          isRequired
                          name={fields.toDate}
                          value={usDateFormat(values[fields.toDate])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.toDate, "")}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.toDate, value)
                              }
                              value={usDateFormat(values[fields.toDate])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              "Required"
                            ) : value < values[fields.fromDate] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-1">
                        <Field
                          size="sm"
                          label="Group by"
                          isRequired
                          name={fields.groupBy}
                          value={values[fields.groupBy]}
                          direction="bottom"
                          onClear={() => setFieldValue(fields.groupBy, 1)}
                          options={groupByOptions}
                          popupContent={
                            <SearchableList
                              label="Select Type"
                              options={groupByOptions}
                              onSelect={(value) => {
                                setValues({
                                  ...values,
                                  [fields.groupBy]: value,
                                });
                                setFieldValue(
                                  fields.groupby,
                                  values[fields.groupBy]
                                );
                              }}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <div className="w-100 d-flex justify-content-start">
                      <Button
                        className="sort-button mr-2"
                        variant="secondary"
                        style={{}}
                        onClick={(e) => {
                          setValues({
                            ...clearFieldValues({
                              values,
                              fieldsToClear: [
                                fields.planId,
                                fields.planName,
                                fields.companyId,
                                fields.companyName,
                                fields.sponsorOrganizationName,
                                fields.sponsorOrganizationId,
                                fields.fromDate,
                                fields.toDate,
                                fields.groupBy,
                              ],
                            }),
                          });
                          setFieldValue(fields.groupBy, 1);
                          setFieldValue(fields.planName, null);
                          setFieldValue(fields.planId, null);
                          setFieldValue(
                            fields.fromDate,
                            initialValues.fromDate
                          );
                          setFieldValue(fields.toDate, initialValues.toDate);
                          setPlanList([]);
                          setErrors({});
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        className="sort-button w-fitContent ml-10"
                        variant="secondary"
                        type="submit"
                      >
                        Request Report
                      </Button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default AggregatedPeriodicReport;
